/** Created by azhou on 2019/1/16.*/
<!--企业注册-->
<template>
  <div class="enterprise pt-3 p-4 pb-4 mt-2">
    <div class="w-30 mr-2 info-wrap">
        <div class="d-center-start mb-4" >
          <left-text leftText="注册身份"/>
          <div>{{typeFlag==3?'供应商':'采购商'}}</div>
        </div>
        <left-text-border class=" mb-4"
            leftText="姓名"
            placeholder="请输入姓名"
            v-model="formData.truename"
            required
      
          />
         <left-text-radio class="mb-4"
            leftText="性别"                   
            v-model="formData.sex "
            :options="gender"
            :radio="true"
            required
        
            />
        <left-text-border class="w-100 mb-4"
            leftText="手机号"
            placeholder="请输入手机号"
            v-model="formData.mobile"
            required
        />
        <send-phone-code :phone-number="formData.mobile"
                  input-type="enterprise"
                  :type="typeFlag"
                  :url='code'
                  @getCode="code=>this.formData.sms_code = code"
                  @showError="text=>this._alert(text, null, 'error') "
                  :template="codeTemp"/>
      <div class="button-wrap mt-6 mb-4">
        <el-button  @click="$router.go(-1)" class="w-35">返回</el-button>
        <el-button  @click="submitForm" class="btn-login w-60" >提交注册</el-button>
      </div>
      <div class="mb-3 mt-1 ml-auto mr-auto ">
        <el-checkbox v-model="agreeFlag">同意</el-checkbox>
        <router-link :to="{name:'regDoc',query:{anch:'0'}}">《服务条款》、</router-link>
        <router-link :to="{name:'regDoc',query:{anch:'1'}}">《隐私服务》、</router-link>
        <router-link :to="{name:'regDoc',query:{anch:'2'}}">《免责说明》</router-link>
      </div>
    </div>
    <!-- <el-dialog title="提示" :show-close="false" :visible.sync="finance" width="560px" class="paymentist" :close-on-click-modal="false" top="16%">
      <div class="h3">恭喜您注册成功</div>
      <div class="h6 mt-2 hs">账户和密码已通过短信发送至您的手机</div>
      <el-button @click="onUserCenter()" class="mt-4 mb-2 w-80 btn-login">去完善信息</el-button>
    </el-dialog> -->
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import BMap from '../../../components/BMap/BMap.vue'
  export default {
    name: 'PersonLregister',
    components: {BMap},
    data () {
      return {
        formData:{
          truename:'',                //姓名
          sex:'',                     //性别
          mobile:'',                  //手机号
          sms_code:'',                //验证码
          trace:'1',                  //注册来源             
        },
        /*性别*/
        gender: [
            { id: 1, name:'男'},
            { id: 2, name:'女'},
        ],                     
        agreeFlag:false,               //同意协议
        existence:false,               //酒店名称是否存在
        finance:true,                  //是否显示提交财务弹窗
        
      }
    },
    computed: {
      //1-供应商 2-采购商
      typeFlag() { return this.$route.query.type },
      code () {
        return '/pc/Reglogin/GetRegCode'
      },
      codeTemp () {
        return 'SMS_269225220'
      }
    },
    watch: {},
    methods: {
      ...mapActions(['RegisterPhone','ResetPwd','RegBuyEnterprise',"UserLogin"]),
      position(e){
        this.formData.longitude = e.lng; this.formData.latitude = e.lat;
      },
      /*表单验证*/
      validateForm () {
        let formData=this.formData;
        if (!formData.truename) return { code: false, msg: '请输入姓名' };
        if (!formData.sex) return { code: false, msg: '请选择性别' };
        if (!formData.mobile) return { code: false, msg: '请填写联系人手机号' };
        if (!this.$GFUN.isPhone(formData.mobile)) return { code: false, msg: '手机号填写不正确' };
        if (!formData.sms_code) return { code: false, msg: '请填写验证码' };
        if(!this.agreeFlag)    return { code: false, msg: '请同意协议' };
        this.errorTips = ''
        return { code: true, msg: '表单验证通过' }
      },
      /*提交注册*/
      async submitForm () {
        let result = this.validateForm();
        let _this=this;
        if (result.code) {     
            this.formData.type=this.typeFlag;
            this.RegBuyEnterprise({
              data:this.formData,
              successFun(res){
                //注册成功获取密码登录
                _this.UserLogin({url:'/pc/Reglogin/login',data:{...res.info,needType:1},type: 'user'});
            }});
        } else this._alert(result.msg, null, 'error')
      },
    }
  }
</script>
<style lang="scss" scoped>
  @import '@/assets/css/color.scss';

  .enterprise{
    display: flex;
    justify-content: center;
    width: 96%;
  }
  .existence{
    color: red;
    padding-bottom: 12px;
    text-align: left;
    font-size: 12px;
    text-indent: 10em;
  }
  .register-type-wrap {
    width: 346px;
    margin: auto;
    .register-type {
      background: #eee;
      border: 1px solid #ccc;
      border-radius: 5px;
      height: 35px;
      font-size: 16px;
      flex: 1;
      cursor: pointer;
      &:hover {
        background: var(--smtc-color-primary);
        color: #fff;
      }
    }
    .active {
      background: var(--smtc-color-primary);
      color: #fff;
    }
  }

  .agree-wrap {
    width: 365px;
    margin: 40px auto;
    a {
      color: $loginBlue;
      font-size:14px;
    }
  }

  .el-button.is-disabled:hover {
    color: #fff;
    background-color: $disabledLoginBlue;
    border-color: $disabledLoginBlue;
  }
  .hs{
    color: #666;
  }
  .button-wrap{
    display: flex;
    justify-content: space-between;
  }
</style>
<style>
  .enterprise .radio-group .el-radio__label{
    min-width: 30px !important;
  }
  .mr-auto{
    font-size: 14px;
  }
</style>